// components/SelectorTiendaSoporte.js — F9. Selector EXPLÍCITO de tienda para el superadmin de
// plataforma (Miguel). Lista las tiendas por GET /api/plataforma/tiendas y, al elegir una, pide
// un token nuevo por POST /api/plataforma/actuar-como (que audita el cruce en el backend). Guarda
// el token y recarga, para que toda la app re-resuelva rol/tienda. Visible SÓLO para el superadmin.
import React, { useEffect, useState } from 'react';
import { LifeBuoy } from 'lucide-react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function SelectorTiendaSoporte() {
  const [tiendas, setTiendas] = useState([]);
  const [base, setBase] = useState('');
  const [actual, setActual] = useState('');
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const r = await fetch(`${API}/api/plataforma/tiendas`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
        });
        if (!r.ok) return;
        const d = await r.json();
        if (!vivo) return;
        setTiendas(d.tiendas || []);
        setBase(d.base || '');
        setActual(d.actuandoComo || d.base || '');
      } catch (_) { /* silencioso: es tooling de soporte */ }
    })();
    return () => { vivo = false; };
  }, []);

  async function elegir(tiendaId) {
    if (!tiendaId || tiendaId === actual || cargando) return;
    setCargando(true);
    try {
      const r = await fetch(`${API}/api/plataforma/actuar-como`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
        body: JSON.stringify({ tiendaId }),
      });
      if (!r.ok) { setCargando(false); return; }
      const d = await r.json();
      if (d.token) { localStorage.setItem('token', d.token); window.location.reload(); }
      else setCargando(false);
    } catch (_) { setCargando(false); }
  }

  if (!tiendas.length) return null;
  return (
    <label className="selector-tienda-soporte" title="Ver otra tienda como soporte (Netto)">
      <LifeBuoy size={14} aria-hidden="true" />
      <select value={actual} disabled={cargando} onChange={(e) => elegir(e.target.value)} aria-label="Tienda (soporte)">
        {tiendas.map((t) => (
          <option key={t.tiendaId} value={t.tiendaId}>
            {t.nombre}{t.tiendaId === base ? ' (mía)' : ''}
          </option>
        ))}
      </select>
    </label>
  );
}
